var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48348 12.8424C7.48348 14.034 6.51162 15 5.31278 15C4.11393 15 3.14207 14.034 3.14207 12.8424C3.14207 11.6508 4.11393 10.6848 5.31278 10.6848C6.51162 10.6848 7.48348 11.6508 7.48348 12.8424Z",
    fill: "#5DBB3A",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9174 12.8424C14.9174 14.034 13.9455 15 12.7467 15C11.5478 15 10.576 14.034 10.576 12.8424C10.576 11.6508 11.5478 10.6848 12.7467 10.6848C13.9455 10.6848 14.9174 11.6508 14.9174 12.8424Z",
    fill: "#5DBB3A",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.02971C2.25 9.02971 2.98538 8.9503 4.03414 8.8587M4.03414 8.8587C5.46344 8.73386 7.47481 8.58637 9 8.58637C10.5465 8.58637 12.5928 8.738 14.0253 8.86391M4.03414 8.8587C4.03414 8.8587 4.23815 4.17516 6.02643 3.79829C7.20481 3.54995 7.88956 4.59629 9 4.59629C10.1104 4.59629 10.9486 3.51144 12.152 3.79829C13.9148 4.21849 14.0253 8.86391 14.0253 8.86391M14.0253 8.86391C15.0423 8.95329 15.75 9.02971 15.75 9.02971M7.48348 12.8424C7.48348 14.034 6.51162 15 5.31278 15C4.11393 15 3.14207 14.034 3.14207 12.8424C3.14207 11.6508 4.11393 10.6848 5.31278 10.6848C6.51162 10.6848 7.48348 11.6508 7.48348 12.8424ZM7.48348 12.8424C7.48348 12.8424 8.4073 12.6355 9.02974 12.6355C9.65217 12.6355 10.576 12.8424 10.576 12.8424M10.576 12.8424C10.576 14.034 11.5478 15 12.7467 15C13.9455 15 14.9174 14.034 14.9174 12.8424C14.9174 11.6508 13.9455 10.6848 12.7467 10.6848C11.5478 10.6848 10.576 11.6508 10.576 12.8424Z",
    stroke: "#5DBB3A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestIcon);
export default __webpack_public_path__ + "static/media/questIcon.059ebd4580320fe7e261764e36e64e91.svg";
export { ForwardRef as ReactComponent };